<template>
    <common-modal width="huge">
        <common-content-spacer height="medium">
            <common-page-header
                size="medium"
                :heading="$t('pages.company.custom_reminders.info_modal.title')"
                :isCenter="true"
            ></common-page-header>
            <div>
                <div
                    class="info_modal--text"
                    v-html="
                        $t('pages.company.custom_reminders.info_modal.text', { n: smsPriceForInfoText, m: emailPriceForInfoText })
                    "
                ></div>
            </div>
            <common-buttons>
                <common-button
                    type="secondary"
                    :isSubmittable="false"
                    :isProcessing="false"
                    :label="$t('common.microcopy.back')"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>
<script>
    import CurrencyEnum from 'enums/currency.enum'

    export default {
        props: {
            showPriceRSD: { type: Boolean, default: true },
        },

        computed: {
            smsPriceForInfoText() {
                return this.showPriceRSD
                    ? `${env('VUE_APP_SMS_PRICE_RSD')} ${CurrencyEnum.RSD} ${this.$t(
                          'pages.company.custom_reminders.info_modal.price',
                      )}`
                    : `${env('VUE_APP_SMS_PRICE_BAM')} ${CurrencyEnum.BAM}`
            },
            emailPriceForInfoText() {
                return this.showPriceRSD
                    ? `${env('VUE_APP_EMAIL_PRICE_RSD')} ${CurrencyEnum.RSD} ${this.$t(
                          'pages.company.custom_reminders.info_modal.price',
                      )}`
                    : `${env('VUE_APP_EMAIL_PRICE_BAM')} ${CurrencyEnum.BAM}`
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .info_modal {
        &--text {
            padding-left: 20px;
        }
    }
</style>
